//import Vue from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import filters from '../../../Shared/filters';
import { ensureModelObjectId } from '../ControlDesigner/controlDesignerSelectionSync.js';

/*********
 * 
 *   DESIGNER base component
 * 
 *   !!! Don't confuse this version with the normal version, this is the DESIGNER version !!!
 * 
 *********/

var baseDesignerMixin = {
    data: function () {
        return {
            master_key: utils.generateUUID(),
            pickervisible: false,
            //picker: null,
            pickertarget: 'body',
        }
    },
    computed: {
        utils: function () {
            return utils;
        },
        Base: function () {
            let p = this;

            while (p && !p.isbase)
                p = p.$parent;

            return p || this.root._self;
        },
        GlobalVars: function () {
            return utils.global_variables;
        },
        ServiceVars: function () {
            return utils.service_variables;
        },
        System: function () {
            return {
                LocalStorage: function (key, value) {
                    var context = "";

                    //if (this.careTokenService)
                    //    context = this.careTokenService.UserID() + '_' + this.careTokenService.CustomerID();

                    if (value === undefined)
                        return localStorage.getItem('user.' + context + '.' + key);
                    else if (value == null)
                        localStorage.removeItem('user.' + context + '.' + key);
                    else
                        localStorage.setItem('user.' + context + '.' + key, value);
                },
                UserLocalStorage: function (key, value) {
                    var context = "";

                    //if (this.careTokenService)
                    //    context = this.careTokenService.UserID();

                    if (value === undefined)
                        return localStorage.getItem('user.' + context + '.' + key);
                    else if (value == null)
                        localStorage.removeItem('user.' + context + '.' + key);
                    else
                        localStorage.setItem('user.' + context + '.' + key, value);
                },
                NoContextLocalStorage: function (key, value) {
                    if (value === undefined)
                        return localStorage.getItem('user.' + key);
                    else if (value == null)
                        localStorage.removeItem('user.' + key);
                    else
                        localStorage.setItem('user.' + key, value);
                },
            };
        },
        Name: function () {
            return this.controlData ? (this.controlData.Name || 'unnamed') : 'no control data';
        },
        Root: function () {
            return this.root;
        },
        Parent: function () {
            let p = this.$parent;

            // Look for a parent object that is a CallCorp control (skip native vue controls)
            while (p && !p.root) {
                if (p.$attrs && 'c_context' in p.$attrs)
                    p = p.$attrs.c_context;
                else
                    p = p.$parent;
            }

            return p;
        },
        Vars: function () {
            return this.controlData ? this.controlData.Vars : {};
        },
        DesignModel: function () {
            return this.designmodel;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
    },
    async created() {
    },
    mounted() {
        this._registerWithDesignerRoot();
    },
    updated() {
        this._registerWithDesignerRoot();
    },
    unmounted() {
        this.Root?.unregisterDesignerComponent?.(this);
    },
    methods: {
        ...methods,
        ...filters,
        _registerWithDesignerRoot() {
            if (this.designmodel)
                ensureModelObjectId(this.designmodel);
            this.Root?.registerDesignerComponent?.(this);
        },
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
            e.preventDefault();
        },

        addControl(e, target) {
            this.pickertarget = target;
            //this.picker = <ControlPicker confirm={this.confirmAddControl} cancel={this.cancelAddControl}></ControlPicker>;
            this.pickervisible = true;
            e.cancelBubble = true;
            e.stopPropagation();
        },
        async confirmAddControl(id) {
            this.pickervisible = false;

            try {
                const schema_ = await utils.schema.get(id);
                const schema = utils.schema.resolve_Of(schema_)
                const model = utils.schema.createDefaultModel(schema, this.Root);

                if (typeof this.pickertarget === 'string')
                    switch (this.pickertarget) {
                        case 'header':
                            if (!this.controlData.HeaderControls)
                                this.controlData.HeaderControls = [];

                            this.controlData.HeaderControls.push(model);
                            // Hmmm. How to select the node, it isn't created yet, not until it is rendered when this layout stack re-renders
                            //this.Root.SelectNode(model);
                            break;

                        case 'body':
                            if (!this.controlData.Controls)
                                this.controlData.Controls = [];

                            this.controlData.Controls.push(model);
                            //this.Root.SelectNode(model);
                            break;
                    }
                else if (typeof this.pickertarget === 'object' && Array.isArray(this.pickertarget)) {
                    this.pickertarget.push(model);
                }
            }
            catch (e) {
                alert(e);
            }
        },
        cancelAddControl() {
            this.pickervisible = false;
        },
        pickerInput(value) {
            this.pickervisible = value;
        },
        generatePicker(h) {
            return (
                <QDialog modelValue={this.pickervisible} onUpdate:modelValue={(value) => this.pickerInput(value)}>
                    <div style={{ maxHeight: '80vh', overflow: 'auto', minWidth: '860px', maxWidth: '860px' }}>
                        <ControlPicker confirm={this.confirmAddControl} cancel={this.cancelAddControl}></ControlPicker>
                    </div>
                </QDialog>
            );
        },
    },
    props: {
        name: '',
        root: null,
        designmodel: null,
        type: null,
        parentType: '',
        controlData: {},
    },
};

export default baseDesignerMixin;